import React, { useState } from "react";
import { notification, Button, Table } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";

import {
  useQueryParams,
  NumberParam,
  withDefault,
  StringParam,
} from "use-query-params";
import { useQuery } from "@tanstack/react-query";
import { api, createQuery } from "helpers/api";

import Filters from "./components/Filters";

const MainList = ({
  columns,
  query_name = "",
  query_path = "",
  table_path = "",
  query_context,
  default_sort = "",
  selectable,
  show_checklist = false,
  checked_list,
  updateCheckedList,
}) => {
  const { pathname } = useLocation();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [paginate, setPaginate] = useQueryParams({
    page: withDefault(NumberParam, 1),
    per_page: withDefault(NumberParam, 15),
    sort: withDefault(StringParam, default_sort),
  });

  const [query, setQuery] = useState({});
  const [search_values, setSearchValues] = useState({});
  const { isLoading: is_loading, data } = useQuery(
    [query_name, paginate, query],
    () =>
      api.get(
        `${query_path}?${createQuery({
          context: query_context,
          paginate,
          query,
        })}`
      ),
    {
      retry: false,
      keepPreviousData: true,
      onError: (err) =>
        notification.error({
          message: err?.response?.data?.message || "Wystąpił błąd",
        }),
    }
  );

  const onTableDataChange = (pagination, _, sort, { action }) => {
    if (action === "paginate") {
      setPaginate({
        ...paginate,
        page: pagination.current,
        per_page: pagination.pageSize,
      });
      return;
    }
  };

  const onSearch = ({ name, value, search_method }) =>
    setQuery({
      ...query,
      [name]: { value, search_method },
    });

  const onSelectChange = (newSelectedRowKeys) =>
    setSelectedRowKeys(newSelectedRowKeys);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: null,
  };

  const handleSetSearchValues = (values) => {
    setSearchValues(values);
    if (pathname === "/issues") {
      if (
        values?.worker_billing_status === 0 ||
        values?.administration_billing_status === 0
      ) {
        setPaginate({
          ...paginate,
          page: undefined,
          sort: "service_date__asc",
        });
        return;
      }
      if ([undefined, 2].includes(values?.status)) {
        setPaginate({
          ...paginate,
          page: undefined,
          sort: "service_date__desc",
        });
        return;
      }
      if ([0, 1].includes(values?.status)) {
        setPaginate({
          ...paginate,
          page: undefined,
          sort: "service_date__asc",
        });
        return;
      }
    }
    setPaginate({
      ...paginate,
      page: undefined,
    });
  };

  const table_columns = show_checklist
    ? columns.filter((item) => checked_list.includes(item.dataIndex))
    : columns;

  return (
    <>
      <Filters
        columns={columns}
        search_values={search_values}
        onSearch={onSearch}
        setSearchValues={handleSetSearchValues}
        setQuery={setQuery}
        paginate={paginate}
        setPaginate={setPaginate}
        total_count={data?.meta?.total_count}
        show_checklist={show_checklist}
        checked_list={checked_list}
        updateCheckedList={updateCheckedList}
      />
      <Table
        loading={is_loading}
        rowSelection={selectable ? rowSelection : null}
        columns={[
          ...table_columns,
          table_path
            ? {
                title: "",
                width: 50,
                render: (_, { id }) => (
                  <Link to={`${table_path}/${id}`}>
                    <Button icon={<EditOutlined />} />
                  </Link>
                ),
              }
            : null,
        ].filter(Boolean)}
        scroll={{ x: "100%" }}
        pagination={{
          current: data?.meta?.current_page || 1,
          pageSize: data?.meta?.per_page || 10,
          total: data?.meta?.total_count || 0,
          pageSizeOptions: ["10", "15", "30", "50"],
        }}
        dataSource={data?.data?.map((item) => ({
          ...item,
          key: item.id,
        }))}
        onChange={onTableDataChange}
      />
    </>
  );
};

export default MainList;
